import {useTranslation} from 'react-i18next';

import {SxProps, Typography} from '@mui/material';

import {Editable} from './Editable';
import {transformDate} from '../../../../../utils/dateUtils/dateFormattingUtils';
import * as Types from '../../types';

interface Props {
  sx?: SxProps;
  onEdit?: (formType: Types.ProfileFormType) => void;
  startDate?: string;
}

export const StartDate = ({sx, onEdit, startDate}: Props) => {
  const {t} = useTranslation();
  return (
    <Editable
      sx={{
        ...sx,
      }}
      onEdit={() => onEdit?.('earliest-start-date')}
      testid='earliest-start-date'
    >
      <Typography variant='h2'>{t('applicantProfile.earliestStartDate.title')}</Typography>
      <Typography variant='body1'>{startDate ? transformDate(startDate, 'numeric') : ''}</Typography>
    </Editable>
  );
};
